import { ForwardedRef, forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { tagVariants } from './variants';
import type { TagProps } from './types';

export const TagWrapper = forwardRef(function (
  { className, variant, children, ...props }: TagProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={cn('eye:tag', tagVariants({ variant }), className)}
      {...props}
    >
      {children}
    </div>
  );
});

TagWrapper.displayName = 'TagWrapper';
